import React, { useMemo } from 'react';
import { Flex, Text } from '@chakra-ui/react';

interface TagProps {
  label: string;
}

const Tag: React.FC<TagProps> = ({ label }) => {
  const statusColor = useMemo(() => {
    if (label === 'Paga') return { text: 'green.300', bg: 'green.200' };

    if (label === 'Em análise') return { text: 'yellow.300', bg: 'yellow.200' };

    return { text: 'gray.500', bg: 'gray.100' };
  }, [label]);

  return (
    <Flex justifyContent="flex-start">
      <Text
        fontWeight={400}
        fontSize="12px"
        py={0.5}
        px={2}
        borderRadius={32}
        bg={statusColor.bg}
        border="1px solid"
        borderColor="blue.400"
        color={statusColor.text}
        textAlign="center"
      >
        {label}
      </Text>
    </Flex>
  );
};

export default Tag;
